import { IShow } from "@evennt-tech/api-v2-core";

export class ShowUtils {
  static getAddress(
    show: Pick<
      IShow,
      | "venueCountry"
      | "venueState"
      | "venueCity"
      | "venueAddress1"
      | "venueAddress2"
      | "postcode"
    >
  ): string {
    return [
      show.venueAddress1,
      show.venueAddress2,
      show.venueCity,
      show.venueState,
      show.postcode,
      show.venueCountry?.name,
    ]
      .filter(Boolean)
      .join(", ");
  }
}
